import { Component, ElementRef, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { RsbService } from 'src/app/service/rsb.service';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-my-teams',
  templateUrl: './my-teams.component.html',
  styleUrls: ['./my-teams.component.css']
})
export class MyTeamsComponent implements OnInit {
  p: number = 1;
  itemsPerPage: number = 5;
  searchText: string = ''; 
  getMyTeamsMembers: Array<any> = [
    {
      name: 'Karan Malhotra',
      mobile: '9876501234',
      createdAt: '2026-08-12T10:00:00',
      type: 'Sales Manager',
      status: 1
    },
    {
      name: 'Simran Kapoor',
      mobile: '9811102233',
      createdAt: '2026-08-20T10:00:00',
      type: 'Channel Partner',
      status: 1
    },
    {
      name: 'Vivek Joshi',
      mobile: '9899001122',
      createdAt: '2026-09-03T10:00:00',
      type: 'Agent',
      status: 0
    },
    {
      name: 'Aakash Bansal',
      mobile: '9877112233',
      createdAt: '2026-09-04T10:00:00',
      type: 'Agent',
      status: 1
    },
    {
      name: 'Nisha Arora',
      mobile: '9811223344',
      createdAt: '2026-09-05T10:00:00',
      type: 'Channel Partner',
      status: 1
    },
    {
      name: 'Rohan Khanna',
      mobile: '9899334455',
      createdAt: '2026-09-06T10:00:00',
      type: 'Sales Executive',
      status: 1
    },
    {
      name: 'Kavita Menon',
      mobile: '9822445566',
      createdAt: '2026-09-07T10:00:00',
      type: 'Agent',
      status: 0
    },
    {
      name: 'Arjun Sethi',
      mobile: '9800556677',
      createdAt: '2026-09-08T10:00:00',
      type: 'Sales Executive',
      status: 1
    },
    {
      name: 'Maya Dutta',
      mobile: '9866778899',
      createdAt: '2026-09-09T10:00:00',
      type: 'Channel Partner',
      status: 1
    }
  ];
  filteredMembers: Array<any> = this.getMyTeamsMembers;
  isShow:boolean=false;
  isShowAddTeam: boolean = false;
  mobileError: string | null = null;
  totalPagesArray: number[] = [];

  member = {
    name: '',
    mobileNumber: '',
    role: ''
  };

  team = {
    teamName: '',
    teamDescription: ''
  };

  constructor(
    private rsbService: RsbService,
    private lookupModel: RsbLookupModel,
    private el: ElementRef,
    private toastrService: ToastrService

  ) { }

  ngOnInit(): void {
  }
  goToPage(page: number) {
    this.p = +page; // Update the current page
  }
  validateMobileNumber() {
    const mobileNumber = this.member.mobileNumber;
    if (mobileNumber && mobileNumber.length !== 10) {
      this.mobileError = 'Mobile number must be exactly 10 digits.';
    } else {
      this.mobileError = null; // Clear error if valid
    }
  }
 
  addPage(): void{
    this.isShow=true;
  }
  closePage(): void{
    this.isShow=false;
  }

  addTeamPage(): void {
    this.isShowAddTeam = true;
  }

  closeTeamPage(): void {
    this.isShow = false;
  }

  onAddTeamSubmit(form: NgForm) {
    if (form.valid) {
      this.rsbService.addBuilderTeam(this.member).subscribe(
        (rsp: any) => {
          if (rsp?.statusCode === 0) {
            this.toastrService.success('Team has been added successfully.', 'Success');
            this.getTeamsMembers();
            this.member = {
              name: '',
              mobileNumber: '',
              role: ''
            };
            form.reset();
            this.closeTeamPage();
          } else {
            this.toastrService.error('Something went wrong.', 'Error');
          }
        },
        (error: any) => {
          console.error('Error adding team:', error);
          this.toastrService.error('Error adding team.', 'Error');
        }
      );
    } else {
      this.toastrService.error('Please fill all required fields.', 'Error');
    }
  }
  

//  onSubmit(form: NgForm) {
//    alert('onSubmit called');
//   console.log('onSubmit called');

//   console.log('Member:', this.member);

//   if (form.valid && this.mobileError === null) {

//     this.rsbService.myTeamsMembers(this.member).subscribe(

//       (rsp: any) => {

//         console.log('API Response:', rsp);

//         if (rsp?.statusCode === 0) {

//           alert('Success');

//           this.closePage();

//         } else {

//           alert('Status Code = ' + rsp?.statusCode);

//         }

//       },

//       (error: any) => {

//         console.log(error);
//         alert('API Error');

//       }

//     );

//   }

//   console.log('Submit clicked');
//   console.log('Member Data:', this.member);

//   if (form.valid && this.mobileError === null) {

//     this.rsbService.myTeamsMembers(this.member).subscribe(

//       (rsp: any) => {

//         console.log('Response:', rsp);

//         if (rsp?.statusCode === 0) {

//           console.log('Success');

//           this.toastrService.success('Team member has been added successfully.');

//           this.getTeamsMembers();

//           this.member = {
//             name: '',
//             mobileNumber: '',
//             role: ''
//           };

//           form.reset();

//           this.closePage();

//         } else {

//           console.log('Status Code:', rsp?.statusCode);

//           this.toastrService.error('Something went wrong.');

//         }

//       },

//       (err) => {

//         console.log('API Error:', err);

//       }

//     );

//   } else {

//     console.log('Form Invalid');

//   }

// }

  getTeamsMembers() {
    this.rsbService.getTeamMembers({}).subscribe(
      (rsp: any) => {
        if (rsp?.statusCode === 0 && rsp?.contents) {
          this.getMyTeamsMembers = rsp.contents;
          this.filteredMembers = rsp.contents;
        } else {
          console.error('Error fetching team members');
          this.toastrService.error('Failed to fetch team members', 'Error');
        }
      },
      (error: any) => {
        console.error('Error fetching team members:', error);
        this.toastrService.error('Error fetching team members', 'Error');
      }
    );
  }

  applyFilter() {
    if (!this.searchText) {
      this.filteredMembers = this.getMyTeamsMembers;
    } else {
      const lowercasedSearchText = this.searchText.toLowerCase();
      this.filteredMembers = this.getMyTeamsMembers.filter(member =>
        (member?.personalDetails?.firstName?.toLowerCase().startsWith(lowercasedSearchText)) ||
        (member?.personalDetails?.mobile?.toLowerCase().startsWith(lowercasedSearchText)) ||
        (member?.personalDetails?.email?.toLowerCase().startsWith(lowercasedSearchText)) ||
        (member?.city?.toLowerCase().startsWith(lowercasedSearchText))
      );
    }
  }

  onSearchChange() {
    this.applyFilter();
  }
}